import React from 'react';
import { useRefundAnimation } from '../../../hooks/useRefundAnimation';
import { REFUND_AMOUNT } from '../hero-fold/constants';

const HomepageRefundStrip: React.FC = () => {
  const { refundTextRef } = useRefundAnimation(REFUND_AMOUNT);

  return (
    <div className="bg-white xl:py-3 mt-10 mb-5 text-xl sm:text-sm sm:mt-0 text-font-500 sm:mb-4 font-medium text-center xl:w-[420px] xl:px-5 rounded-[200px] px-3 lg:w-[400px] md:text-base md:w-80 py-2 sm:w-[300px]">
      <span
        className="refund-text font-bold text-green-600"
        id="hero-refund-number"
        ref={refundTextRef}
      >
        0.00
      </span>{' '}
      Refund processed this year
    </div>
  );
};

export default HomepageRefundStrip;
